import { BiHomeSmile } from "react-icons/bi";
import { MdNavigateNext } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import React from "react";
/* eslint-disable-next-line */

export function BreadCrumbs() {
  const location = useLocation();
  const [state, setState] = useState<any>();
  useEffect(() => {
    if (location) {
      const _paths = location.pathname.split("/");
      _paths.shift();
      const path =
        _paths &&
        _paths.map((_path, i) => {
          let path = "";
          for (let a = 0; a < i + 1; a++) {
            path += "/" + _paths[a];
          }
          return { path, name: _path.charAt(0).toUpperCase() + _path.slice(1) };
        });
      setState(path.slice());
    }
  }, [location]);
  return (
    <div className="hidden sm:flex items-center justify-start flex-wrap mb-8">
      <Link to="/">
        <BiHomeSmile className="text-primary text-xl mb-1 animate hover:scale-105 cursor-pointer" />
      </Link>
      {state &&
        state.map((link: any, i: any) => (
          <React.Fragment key={i}>
            <MdNavigateNext className="text-gray-500text-xl mx-0.5  animate cursor-pointer" />
            <Link to={link.path} className=" text-gray-400 hover:text-primary animate cursor-pointer">
              {link.name}
            </Link>
          </React.Fragment>
        ))}
    </div>
  );
}

export default BreadCrumbs;
